import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify, {
    customPorperties: true,
});

const opts = {};

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: "#1d8ead",
                grey: "#606060",
                userPolygon: "#FFD207",
                otherPolygon: "#1d8ead",

                // secondary: '#424242',
                // accent: '#82B1FF',
                error: "#AE172B",
                info: "#2058A2",
                success: "#066735",
                warning: "#765300",
            },
        },
    },
});
